import { OverlayType } from '../../components/Overlay/interfaces';
import { SspProviderContext } from './interfaces';
import { SET_OVERLAY_ACTION } from './store';

export function setOverlay(store: SspProviderContext, overlay: OverlayType | null) {
    store.dispatch({ type: SET_OVERLAY_ACTION, value: overlay });
}
export function setASSubpage(store: SspProviderContext, overlay: OverlayType | null) {
    if (overlay) {
        store.dispatch({ type: 'OPEN_AS_SUBPAGE', value: overlay });
        window.history.pushState({ asEnum: overlay.asEnum }, '');
    } else {
        store.dispatch({ type: 'CLOSE_AS_SUBPAGE' });
        window.history.back();
    }
}
